var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFinger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "one-finger-drag-horizontal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 427318719"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 107",
    d: "M6.80156 18.7829L5.78095 17.7255L5.51828 17.4537C4.28706 16.1794 4.77346 14.06 6.43706 13.4501L6.95548 13.2601L5.62531 6.04593C5.47026 5.11699 6.09763 4.23826 7.02658 4.08321C7.95552 3.92819 8.83426 4.55556 8.98929 5.4845L10.0164 10.8825L13.1178 10.3649C15.1201 10.0308 17.0142 11.3831 17.3484 13.3854L17.8968 16.671",
    stroke: "currentColor",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1149",
    d: "M11.486 4.8148C11.0704 2.50074 8.80643 0.970897 6.42926 1.39781C4.05208 1.82472 2.46189 4.04673 2.87747 6.36079",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFinger);
export default __webpack_public_path__ + "static/media/icon-finger.c5f8af126700cf57b7c7d5e0d7c47da6.svg";
export { ForwardRef as ReactComponent };